import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BulkHistoryComponent } from './bulk-history.component';
import { BulkHistoryDetailModalComponent } from './bulk-history-detail-modal/bulk-history-detail-modal.component';
// Import other necessary modules (Kendo, Ngb, etc.)
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NgbModalModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DateRangeSelectionModule } from "../../forecastui/date-range-selection/date-range-selection.module";
import { GridModule } from '@progress/kendo-angular-grid';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DropDownsModule,
    NgbModalModule,
    NgbTooltipModule,
    DateRangeSelectionModule,
    GridModule,
    ButtonsModule
],
  declarations: [BulkHistoryComponent, BulkHistoryDetailModalComponent],
  exports: [BulkHistoryComponent]
})
export class BulkHistoryModule { }
